import React from 'react';

import logo from '../../assets/image/logo.png';

import useStyles from './styles';

interface ManabieLogoProps {
  maxWidth?: string
}

const ManabieLogo = ({maxWidth}: ManabieLogoProps) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
        <img
          className={classes.logo}
          src={logo}
          alt="Manabie logo"
          title="Manabie logo"
          style={{maxWidth}}
          data-manabie="manabie-logo"
        />
    </div>
  );
};

export default ManabieLogo;